export default "__VITE_ASSET__CZWOgGwW__"